import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import { logKafka, detailsInfo, logOtherInfo, catchJSException } from './../service/logService'
import { Save, CheckOut, BannerTypes, PAGEACTIVITY,CheckLQ } from './../constants/actionType'
import { redirectTo } from './redirection'
import { getCartHeader, getCartData, getCartProducts, getSelectedVoice, getUnsupportedProducts, getCartDataDefault } from './../util/cartUtility'
import { updateSCcustomEvent, tempSCData } from './../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData, vzdlErrorUpdate,updateSubFlowValue } from './../service/vzdl';
import { errorAction } from './error';
import { Pages, CartServices, BuildProduct } from './../constants/actionType'
import * as lqAction from './loopQual';
import * as buildProductAction from './buildProduct';
import * as xpsAction from './xpsEntry';
import { InHomeUtils } from './../util/inhomeUtils';
import * as checkoutAction from './checkout';
import * as loopQualAction from './loopQual';
import { store } from './../index';


export const helpSaveOverlay = (status, dispatch) => {
    dispatch({ type: Save.helpSave, value: status })
};

export const resumeSavedMon = (dispatch, action) => {
    dispatch({ type: Save.resumeSavedMon, value: action });
}

export const sendCartNum = (dispatch, action) => {
    dispatch({ type: Save.sendCartNum, value: action });
}

export const saveModalInput = (dispatch, action) => {
    dispatch({ type: Save.saveModalInput, value: action });
}
export const saveInvoked = (status, dispatch) => {
    dispatch({ type: Save.saveInvoked, value: status })
};
export const backInvoked = (status, dispatch) => {
    dispatch({ type: Save.backInvoked, value: status })
};

export const creditDone = (status, dispatch) => {
    dispatch({ type: Save.creditDone, value: status })
};

export const expiryDate = (status, dispatch) => {
    dispatch({ type: Save.expiryDate, value: status })
};

export const validateInput = (status, dispatch) => {
    dispatch({ type: Save.validateInput, value: status })
};

export const saveLqEmailInput = (dispatch, status) => {
    dispatch({ type: Save.saveLqEmailInput, value: status })
};

export const saveLqMtnInput = (dispatch, status) => {
    dispatch({ type: Save.saveLqMtnInput, value: status })
};

export const saveMHUserIdInput = (dispatch, status) => {
    dispatch({ type: Save.saveMHUserIdInput, value: status})
};

export const saveMHPasswordInput = (dispatch, status) => {
    dispatch({ type: Save.saveMHPasswordInput, value: status})
};

export const emailError = (status, dispatch) => {
    dispatch({ type: Save.emailError, value: status })
};

export const mtnError = (status, dispatch) => {
    dispatch({ type: Save.mtnError, value: status })
};

export const resumeMonErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonErr, value: status })
};

export const sendCartErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartErr, value: status })
};
export const invalidMTNErr = (status, dispatch) => {
    dispatch({ type: Save.invalidMTNErr, value: status })
};

export const resumeMonValueErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonValueErr, value: status })
};

export const resumeMonAttemptErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonAttemptErr, value: status })
};

export const sendCartEmailErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartEmailErr, value: status })
};

export const sendCartMTNErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartMTNErr, value: status })
};

export const sentSmsorEmail = (status, dispatch) => {
    dispatch({ type: Save.sentSmsorEmail, value: status })
};

export const resumeInternetAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeInternetAdded, value: action });
}
export const resumeTvAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeTvAdded, value: action });
}
export const resumeVoiceAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeVoiceAdded, value: action });
}
export const cancelSmartCartClick = (status, dispatch) => {
    dispatch({ type: 'CANCEL_SMARTCARTCLICK', value: status })
};

export const validateSmartSaveEmail = (dispatch, action) => {
    dispatch({ type: Save.onValidateSmartSaveEmail, value: action });
}

export const processSaveCart = (visitId, dispatch, lqState, email, mtn, isProcessCartFailed = false) => {
    try {
        let savejson = saveRequest(lqState, email, mtn,visitId);
        let url = apiUrl().processSave;
        return new Promise((resolve, reject) => {
        api(url, 'POST', savejson).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                dispatch({ type: Save.processSaveCart, value: response.data });
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.couponTokenResponse) && InHomeUtils.isNotNull(response.data.couponTokenResponse.companyToken)  && InHomeUtils.isNotNull(response.data.couponTokenResponse.flowType) && response.data.couponTokenResponse.companyToken !== "") {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'processSaveCart', PAGEACTIVITY.MSG.couponInfoExists, PAGEACTIVITY.UA));
                    dispatch({ type: CheckLQ.updateCouponFlowType, value: response.data.couponTokenResponse.flowType });
                }
                resolve(response);
            }
            else if (!isProcessCartFailed) {
                processSaveCart(visitId, dispatch, lqState, email, mtn, true);
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:processSaveCart,errorMessage:${error.message}`;
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
            resolve(false);
        });
    });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-processSaveCart', ex);
    }
};

export const processSaveCartandRedirect = (visitId, dispatch, lqState, isProcessCartFailed = false) => {
    try {
        let savejson = saveRequestRedirect(lqState,visitId);
        let url = apiUrl().processSave;
        if (!isProcessCartFailed) {
            dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
            });
        }
        api(url, 'POST', savejson).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta)  && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                dispatch({ type: Save.processSaveCart, value: response.data });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                redirectTo(Pages.SmartSave, dispatch)
            }
            else if (!isProcessCartFailed) {
                processSaveCartandRedirect(visitId, dispatch, lqState, true);
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:processSaveCartandRedirect,errorMessage:${error.message}`;
            logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-processSaveCartandRedirect', ex);
    }
};

export const sendSmsOrEmail = (visitId, dispatch, mon, smsOrEmail, isMtn) => {
    try {
        if(visitId){
            let requestJson = sendRequest(mon, smsOrEmail, isMtn,visitId);
            let url = apiUrl().sendSmsOrEmail;        
            api(url, 'POST', requestJson).then(response => {
                if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    dispatch({ type: Save.sendSmsorEmail, value: response.data });
                    sentSmsorEmail(true, dispatch);
                }
            })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:sendSmsOrEmail,errorMessage:${error.message}`;
                logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        }
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-sendSmsOrEmail', ex);
    }
};

//Smartcart changes for EC flow
export const smartCartSaveWithParamForEc = (dispatch, visitId, smsOrEmail, isMtn, mon, isCreditCompleted, saveLQEmailInfo, isFCPflow, isDoFlow,lqState) => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Saving your cart", isLoaderImg: "loader" }
        });
        let prospectUpdate = true;
       
        let url = apiUrl().smartSave;
        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: isMtn ? smsOrEmail : "",
            saveType: 'proactive',
            prospectUpdate: prospectUpdate ? "Y" : "",
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)){
                if (InHomeUtils.isNotNull(response.meta.description) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    dispatch({ type: Save.smartSave, value: response.meta.description });
                    dispatch({ type: 'CART_SAVE_ON_UPDATE', value: false });
                    saveInvoked(true, dispatch);                                       
                    if (mon !== "") {                        
                        //suppressing the ECRM sendSmsOrEmail trigger by runtimekey                        
                        if ((window.location.href.indexOf('isECRMTriggerForSmartCart=n') > -1) ||
                            (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.isECRMTriggerForSmartCart) && InHomeUtils.isNotEmpty(lqState.runtimeKey.isECRMTriggerForSmartCart) && lqState.runtimeKey.isECRMTriggerForSmartCart.toUpperCase() === "N")) {
                            //ECRM trigger disabled case
                            console.log("ECRM trigger disabled")
                        }
                        else {
                            //ECRM trigger enabled case
                            console.log("ECRM trigger enabled")
                            sendSmsOrEmail(visitId, dispatch, mon, smsOrEmail, isMtn);
                        }
                    }
                    tempSCData.detailPageName = "smart cart confirmation| " + ((isCreditCompleted) ? " post credit" : " pre credit");                    
                    tempSCData.events = "event5,event22";
                    tempSCData.MON = mon;                    
                    updateSCcustomEvent("saveProactive", "ddPageViewUpdateEvent", "detailPageName,events");
                    //updateVzdlSCCustomEvent("saveProactive","pageViewOmni","detail");                    
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                    vzdlErrorUpdate(response.meta.code,"SaveOrderFail");
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "400")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                    vzdlErrorUpdate(response.meta.code,"SaveOrderFail");
                }
            }
            
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:smartCartSaveWithParam,errorMessage:${error.message}`;
            logKafka("ERROR", "smartCartSaveWithParam", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-smartCartSaveWithParam', ex);
    }
};



export const smartCartSaveWithParam = (dispatch, visitId, smsOrEmail, isMtn, mon, isCreditCompleted, saveLQEmailInfo, lqState, mnhMobileNum = "", buildProductState = null ) => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Saving your cart", isLoaderImg: "loader" }
        });
        let prospectUpdate = false;
        if (saveLQEmailInfo === "") {
            prospectUpdate = true;
        }
        else if (!isMtn && smsOrEmail !== "" && saveLQEmailInfo !== smsOrEmail) {
            prospectUpdate = true;
        }
        //Remove the unrequired junk characters in MTN Info
         if (isMtn && InHomeUtils.isNotNull(smsOrEmail) && InHomeUtils.isNotEmpty(smsOrEmail)) {
            smsOrEmail=smsOrEmail.replace(/[^0-9 ]/g,'');
        } 
        let url = apiUrl().smartSave;
        let isStreamline = store && store.getState() && store?.getState()?.loopQual?.streamlineLQ ? true : false

        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: mnhMobileNum ? mnhMobileNum : isMtn ? smsOrEmail : "",
            saveType: 'proactive',
            prospectUpdate: prospectUpdate ? "Y" : "",
            streamlineflow:isStreamline ? "Y" : "N",
        }
        if((InHomeUtils.isNotNull(request.email) && InHomeUtils.isNotEmpty(request.email)) || (InHomeUtils.isNotNull(request.mtn) && InHomeUtils.isNotEmpty(request.mtn))){
          
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)){
                if (InHomeUtils.isNotNull(response.meta.description) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    dispatch({ type: Save.smartSave, value: response.meta.description });
                    dispatch({ type: 'CART_SAVE_ON_UPDATE', value: false });

                    saveInvoked(true, dispatch)
                    if (mon !== "") {                        
                        //suppressing the ECRM sendSmsOrEmail trigger by runtimekey                        
                        if ((window.location.href.indexOf('isECRMTriggerForSmartCart=n') > -1) ||
                            (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.isECRMTriggerForSmartCart) && InHomeUtils.isNotEmpty(lqState.runtimeKey.isECRMTriggerForSmartCart) && lqState.runtimeKey.isECRMTriggerForSmartCart.toUpperCase() === "N")) {
                            //ECRM trigger disabled case
                            console.log("ECRM trigger disabled")
                        }
                        else {
                            //ECRM trigger enabled case
                            console.log("ECRM trigger enabled")
                            sendSmsOrEmail(visitId, dispatch, mon, smsOrEmail, isMtn);
                        }
                    }
                    tempSCData.detailPageName = "smart cart confirmation| " + ((isCreditCompleted) ? " post credit" : " pre credit");
                    tempVzdlSCData.detail= "smart cart confirmation - " + ((isCreditCompleted) ? " post credit" : " pre credit");
                    tempSCData.events = "event5,event22";
                    tempSCData.MON = mon;                    
                    updateSCcustomEvent("saveProactive", "ddPageViewUpdateEvent", "detailPageName,events");
                    updateVzdlSCCustomEvent("saveProactive","pageViewOmni","detail")
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                    vzdlErrorUpdate(response.meta.code,"SaveOrderFail");
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "400")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                    vzdlErrorUpdate(response.meta.code,"SaveOrderFail");
                }
            }
            
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:smartCartSaveWithParam,errorMessage:${error.message}`;
            logKafka("ERROR", "smartCartSaveWithParam", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    else{
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-smartCartSaveWithParam', ex);
    }
};
export const getHTMLContent = (dispatch,  isHeader) => {
    const url  = isHeader ? apiUrl().ecHeader : apiUrl().ecFooter;
    api(url, 'GET','', 'html' ).then(response => {
        const content = {
            type: isHeader ? 'EC_HEADER' : 'EC_FOOTER',
            value: response
        }
        dispatch(content);
    }).catch(error => {
        vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
        console.log('html error', error);
    });
}

export const smartSave = (dispatch, visitId, saveType, isCreditCompleted, isSaveContinueClick, mon, smsOrEmail, isMtn, isFCPflow, isDoFlow, buildProductState) => {

    try {
        if(buildProductState && buildProductState.emergencyServices && buildProductState.emergencyServices.selectedProduct){
            buildProductAction.updateFireAlarmDetails(visitId, buildProductState.emergencyServices);
        }
        if (saveType === "passive") {
            tempSCData.detailPageName = "smart cart save passive|" + ((isCreditCompleted) ? " post credit" : " pre credit");           
            tempVzdlSCData.detail = "smart cart save passive -" + ((isCreditCompleted) ? " post credit" : " pre credit");           
            updateSCcustomEvent("savePassive", "ddPageViewUpdateEvent", "detailPageName");
            updateVzdlSCCustomEvent("savePassive", "pageViewOmni", "detail");
        }      

        if (isSaveContinueClick) {
            dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
            });
        }
        let url = apiUrl().smartAutoSave;
        api(url, 'GET', '').then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.isNotNull(response.meta.description) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                dispatch({ type: Save.smartSave, value: response.meta.description });
                dispatch({ type: 'CART_SAVE_ON_UPDATE', value: false });

                if (isSaveContinueClick) {
                    saveInvoked(true, dispatch)
                    if (mon !== "") {
                        sendSmsOrEmail(visitId, dispatch, mon, smsOrEmail, isMtn);
                    }
                    expiryDate(saveDate(), dispatch)
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:smartSave,errorMessage:${error.message}`;
            logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            if (isSaveContinueClick) { dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); }
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-smartSave', ex);
    }
};


export const resumeSmartCart = async(dispatch, visitId, noOfAttempts, creditCheckCompleted, personalInfoCompleted, isLbo, buildProductState, saveState,lqState,cart,firstBill, isResumeCartFailed = false) => {
    let qString = 'RESUMECART-LQ-SYSTEMERROR';
    let errorMessage = 'RESUMECART-LQ-SYSTEMERROR';
    try {
        if (noOfAttempts < 3) {
            let url = apiUrl().resumeSmartCart;            
            url =url+"?from=LQ";
            if(window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true')) {
                url = url + '&isMnFlow=Y';
            }
            if (isLbo) {
                errorMessage = 'LQ-UNSUPPORTED';
                dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                errorAction("LBO", "BuildProduct", errorMessage, "", visitId, dispatch, true, errorMessage);
            } else {
                if (!isResumeCartFailed) {
                    dispatch({
                        type: 'LOADER_ACTIVE',
                        value: { isLoaderActive: true, isLoaderText: "Resuming your cart", isLoaderImg: "loader" }
                    });
                }
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCart-Api', "Triggering ResumeSmartCart Api", PAGEACTIVITY.UA));
                const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
                if (isFiOSFlag) {
                    sessionStorage.setItem("longDurationAPI", "on");
                }                 
                api(url, 'GET', '').then(async(response) => {
                    const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
                    if (isFiOSFlag) {
                        sessionStorage.setItem("longDurationAPI", "off");
                    }
                    dispatch({ type: Save.updateResumeAttempts, value: noOfAttempts + 1 })
                    if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                        xpsAction.captureSCResumeSource(dispatch,'lq',saveState,visitId);                       
                        dispatch({ type: Save.resumeSavedMon, value: response.data });
                        if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.mnHAuth) && InHomeUtils.isNotEmpty(response.data.mnHAuth)){
                            if(response.data.mnHAuth != "")
                                updateSubFlowValue(' | M+H', 'm+h');
                            dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnHAuth});
                        }
                        //Revalidate the Winback TN  for Smart Cart resume   
                        if (InHomeUtils.isNotNull(response.data.winback) && response.data.winback === "Y" && InHomeUtils.isNotNull(response.data.wtn) && InHomeUtils.isNotEmpty(response.data.wtn) && response.data.wtn.length === 10) {
                            try {
                                let tnPortableCheckResp = await buildProductAction.tnPortableCheck(response.data.wtn, dispatch, visitId, false);
                                if (tnPortableCheckResp) {
                                    if (InHomeUtils.isNotEmpty(response.data.wtn)) {
                                        dispatch({ type: "RESUME_WINBACKTN", value: response.data.wtn })
                                        saveState.resumeWinbackTN = response.data.wtn
                                    }
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCartXps', PAGEACTIVITY.MSG.resumeWB, PAGEACTIVITY.UA));
                                    dispatch({ type: "RESUME_ISWINBACK", value: true })
                                    saveState.resumeIsWinback = true;
                                }

                            }
                            catch (ex) {
                                catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'action-tnPortableCheck', ex);
                            }

                        }
                        if((InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.isRAFEnabled) && lqState.runtimeKey.isRAFEnabled ==="Y") && InHomeUtils.isNotNull(response.data.rafSTNID) && InHomeUtils.isNotEmpty(response.data.rafSTNID)){
                            dispatch({ type: "RESUME_RAFPACKAGE_COUPONVALIDATION", value: response.data.rafSTNID });                
                        }
                        //F&F change for getting FF details during smart cart retrieve                        
                        if(InHomeUtils.isNotNull(response.data.friendsAndFamily) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily) && InHomeUtils.isNotNull(response.data.friendsAndFamily.ffCouponCode) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily.ffCouponCode) && InHomeUtils.isNotNull(response.data.friendsAndFamily.ffLeadListId) && InHomeUtils.isNotEmpty(response.data.friendsAndFamily.ffLeadListId)){
                            let ffValidationInfo = {
                                ffCoupon: response.data.friendsAndFamily.ffCouponCode,
                                leadListID: response.data.friendsAndFamily.ffCouponCode.ffLeadListId,
                                ffCouponError: false,
                                ffValidationSucess: true,
                                ffValidationFailure: false,
                                ffValidationErrorType:  '', 
                                isFFCheckoutValidation: false,
                                profileDataSpeed:''
                            }
                            dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                        }

                        //Visible & prePaid change
                        if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data) && response.data.visPreCouponCode && InHomeUtils.isNotEmpty(response.data.visPreCouponCode)) {
                            let visPreCouponInfo = {
                             visPreCoupon:  response.data.visPreCouponCode,
                             leadListID: null,
                             visPreCouponError: false,
                             visPreValidationSucess: true,
                             visPreValidationFailure: false,
                             visPreValidationErrorType: '',
                             isVisPreCheckoutValidation: false,
                             isDiscountEligible: true,
                             isDiscountApplied: true
                           }
                           dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreCouponInfo });
                         }

                        //VZ Connections change for getting token info during resume smart cart
                        if(InHomeUtils.isNotNull(response.data.tokenInfo) && InHomeUtils.isNotNull(response.data.tokenInfo.companyToken) && InHomeUtils.isNotEmpty(response.data.tokenInfo.companyToken) && InHomeUtils.isNotNull(response.data.tokenInfo.customerToken) && InHomeUtils.isNotEmpty(response.data.tokenInfo.customerToken) && InHomeUtils.isNotNull(response.data.tokenInfo.tokenType) && InHomeUtils.isNotEmpty(response.data.tokenInfo.tokenType) && response.data.tokenInfo.tokenType.toLowerCase().indexOf('vzconnection') > -1){
                            let vzcCouponInfo = {
                                vzcCoupon: response.data.tokenInfo.customerToken,
                                vzcValidationSuccess: true,
                                isDiscountEligible: true
                            }
                            dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo }); 
                        }

                        if (creditCheckCompleted && InHomeUtils.isNotNull(response.data.dataDepositAmount) && response.data.depositRequired === "Y" && response.data.dataDepositAmount !== "" && response.data.dataDepositAmount > 0) {
                            dispatch({ type: CheckOut.updateDepositInfo, value: true })
                            dispatch({ type: CheckOut.updateDepositAmount, value: response.data.dataDepositAmount })
                        }
                        //Advantage Offer
                        if(InHomeUtils.isNotEmpty(response.data.vzwOffer)){
                            lqAction.updateVZWResponse(dispatch,response.data.vzwOffer)
                        }
                        //fetch all banners and store
                        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotEmpty(lqState) && InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey) && lqState.runtimeKey.BFHoliday2021 && (lqState.runtimeKey.BFHoliday2021 === 'BF' || lqState.runtimeKey.BFHoliday2021 === 'H' )) {
                            //lqAction.updateBannerType(BannerTypes.BlackFriday2020, dispatch);
                        }else{
                        lqAction.updateBannerType(BannerTypes.ResumeCart, dispatch)
                        }
                        lqAction.fetchBanners(dispatch, visitId);
                        lqAction.fetchFlashOfferDetails(dispatch, visitId);
                        lqAction.isFCPflow(response.data.fcpFlow, dispatch);
                        let enableceApps = lqState && lqState.runtimeKey && lqState.runtimeKey.enableceapps && lqState.runtimeKey.enableceapps.toUpperCase() === 'Y' && response.data.fcpFlow;
                        buildProductState.showConnectedApps = enableceApps
                        dispatch({ type: 'SHOW_CONNECTED_APPS_EXP', value: enableceApps });  
                        setTimeout(function () {
                            loadCartForSmartCart(visitId, dispatch, creditCheckCompleted, personalInfoCompleted, buildProductState, saveState,lqState,cart,firstBill);
                        }, 1000);                        
                        updateVzdlSCCustomEvent("resumeSavedCart", "pageViewOmni", "");
                    }
                    else if (!isResumeCartFailed) {
                        resumeSmartCart(dispatch, visitId, noOfAttempts, creditCheckCompleted, personalInfoCompleted, isLbo, buildProductState, saveState,lqState,cart,firstBill, true);                        
                    }
                    else {
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                       
                        let apiError = "";
                        if (InHomeUtils.isNull(response)) {
                            errorMessage += '-ResponseNull';
                        } else {
                            if (InHomeUtils.isNull(response.data)){
                                errorMessage += '-DataNull';
                            }

                            if (InHomeUtils.isNotNull(response.meta)) {
                                if(InHomeUtils.isNotNull(response.meta.code)){
                                    errorMessage += '-' + response.meta.code;
                                }
                                
                                if (InHomeUtils.isNotNull(response.meta.description)){
                                    apiError = response.meta.description;
                                }
                            }
                        }
                        
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'resumeSmartCart', PAGEACTIVITY.MSG.resumeMONError + ":" + errorMessage + "-"+ apiError, PAGEACTIVITY.UA));
                        if(InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y") {
                            dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                            errorAction("LBO", "BuildProduct", errorMessage, "applogs", visitId, dispatch, true, qString);
                            vzdlErrorUpdate(response.meta.code,errorMessage);
                        }
                        else
                        {
                            updateSCcustomEvent("smartResumeError", "ddPageViewUpdateEvent", "detailPageName");
                            updateVzdlSCCustomEvent("smartResumeError", "pageViewOmni", "detail");
                            resumeMonValueErr(true, dispatch);
                            resumeMonAttemptErr(false, dispatch);
                        }
                    }
                })
                .catch(error => {
                    const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
                    if (isFiOSFlag) {
                        sessionStorage.setItem("longDurationAPI", "off");
                    }
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    let errorMsg = `MethodName:resumeSmartCart,errorMessage:${error.message}`;
                    logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
            }
        }
        else
        {
            updateSCcustomEvent("smartResumeError", "ddPageViewUpdateEvent", "detailPageName");
            updateVzdlSCCustomEvent("smartResumeError", "pageViewOmni", "detail");
            resumeMonValueErr(false, dispatch);
            resumeMonAttemptErr(true, dispatch);
        }
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-resumeSmartCart', ex);
    }
};

const filterFiosFiveBasicChannels = (lstChannels, prodId) => {
    let lstMatchedChannel = [];

    if (prodId) {
        prodId = prodId.toUpperCase();
        lstMatchedChannel = lstChannels.filter((el) => {
            return (el.id.toUpperCase().indexOf(prodId) !== -1)
        });
    }
    return lstMatchedChannel;
};

// Resumecartflow fisofiveselected channels issue fix
const formatSelectedFiosFiveChannels = (cartDataChannels) => {
    cartDataChannels = cartDataChannels.map(val =>{
        val.id = val.id || val.prodId;
        val.name = val.name || val.prodName;
        val.logo = val.logo || val.id+'.png';
        return val;
        }).filter(item => {
           // prodType: 'BASIC_FF', //Todo
           let prodTypeVal = item.prodTypeVal ? item.prodTypeVal.trim(): ''
            return prodTypeVal.toLowerCase() !== "musthavea" && prodTypeVal.toLowerCase() !== "musthaveb";
        });
        return cartDataChannels;
}

export const loadCartForSmartCart = (visitId, dispatch, creditCheckCompleted, personalInfoCompleted, buildProductState, saveState,lqState,cart,firstBill, isLoadCartFailed = false) => {
    let qString = 'LOADCART-LQ-SYSTEMERROR';
    let errorMessage = 'LOADCART-LQ-SYSTEMERROR';
    try {
        let getCart = apiUrl().getCartAcc + '/' + visitId;
        let status = ''; let errorMsg = '';
        let voiceProduct=null;
        api(getCart, 'GET', '').then(response => {
            if (InHomeUtils.isNull(response)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.retrieveCartResponseEmptyorNull, PAGEACTIVITY.UA));
                errorMsg = "ResponseNull";
            }else{
                if (InHomeUtils.isNull(response.data)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.retrieveCartDataNull, PAGEACTIVITY.UA));
                    errorMsg = "DataNull";
                }
            }

            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                if(InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered) && response.data.orderDetail.servicesOrdered !== '') {
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));

                        try {
                            if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections)  && response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.length > 0) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                            }
                        }
                        catch (ex) {
                            catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', ex);
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                    }
                    if (InHomeUtils.isNotNull(response.data.cartTierPricing) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)){
                        let cartDataOnResume = getCartDataDefault();
                        cartDataOnResume = getCartData(response.data.cartTierPricing.tierContent, visitId);

                        dispatch({
                            type: "UPDATE_CART",
                            value: {
                                cartResponse: response.data.cartTierPricing,
                                cartHeader: getCartHeader(response.data.cartTierPricing.tierContent,visitId),
                                cartData: cartDataOnResume,
                                cartOrderDetail: response.data.orderDetail
                            }
                        });

                        /* Disney perk promo changes -- planned during Oct 7th, 2024 to Nov 6th, 2024
                          For disney perk promo changes
                        */
                       if(response?.data?.cartTierPricing?.tierContent?.length > 0) {
                        const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                        const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers');
                            let disneyPromoEligible = false;
                            offers?.promos?.forEach(promo => {
                                if(promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_TRACKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_MARKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT') {
                                    disneyPromoEligible = true;
                                }
                            });
                            dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                        }

                        if (InHomeUtils.isNotNull(response.data.atvQual) && response.data?.atvQual == true){
                            dispatch({type : 'ANDROID_TV_STB',value : true})
                        }
                        else{
                            dispatch({type : 'ANDROID_TV_STB',value : false})
                        }
                       
                        if (InHomeUtils.isNotNull(cartDataOnResume) && InHomeUtils.isNotNull(cartDataOnResume[0]) 
                            && InHomeUtils.isNotNull(cartDataOnResume[0].fiosFiveSelectedChannels) && cartDataOnResume[0].fiosFiveSelectedChannels.length > 0) {
                                let cartDataChannels = [];
                                if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveBasicChannels) && buildProductState.tv.fiosFiveBasicChannels.length > 0) {
                                    cartDataOnResume[0].fiosFiveSelectedChannels.forEach((item) => {
                                        let matchesFound = filterFiosFiveBasicChannels(buildProductState.tv.fiosFiveBasicChannels, item);
                                        if (matchesFound && matchesFound.length) {
                                            cartDataChannels.push(matchesFound[0]);
                                        }
                                    })

                                    if(cartDataChannels.length >0){
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }else{
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }
                                }else{
                                    cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                }
                            }

                        if (InHomeUtils.isNotNull(cart) ) {
                            cart.cartResponse=response.data.cartTierPricing;
                            cart.cartHeader= getCartHeader(response.data.cartTierPricing.tierContent,visitId);
                            cart.cartData= cartDataOnResume;
                            cart.cartOrderDetail=response.data.orderDetail;
                        }

                        voiceProduct = getSelectedVoice(response.data.cartTierPricing,visitId);
                        if (InHomeUtils.isNotNull(saveState) && InHomeUtils.isNotNull(saveState.resumeIsWinback) && !saveState.resumeIsWinback) {                            
                            if (!saveState.isTNUpdatedForResumeSmartCart && InHomeUtils.isNotNull(voiceProduct) && InHomeUtils.isNotEmpty(saveState.loadTNForSCResume)) {
                                let tn = saveState.loadTNForSCResume;
                                if (tn !== "" && tn !== "1000000001" && tn !== "9999999999") {
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateRequestTNForFDV', "Triggering updateRequestTNForFDV", PAGEACTIVITY.UA));                                    
                                    buildProductAction.updateRequestTNForFDV(visitId, tn, dispatch);
                                }
                            }
                        }                        
                    }

                    let cartProducts = getCartProducts(response.data.cartTierPricing,visitId)
                    let contract = '';
                    let resumeFlowType = 'Resume';
                    if (InHomeUtils.isNotNull(response.data.orderDetail)) {
                        if(InHomeUtils.isNotNull(response.data.orderDetail.contract)){
                            contract = response.data.orderDetail.contract;
                        }
                        if(InHomeUtils.isNotNull(response.data.orderDetail.bundleId) && response.data.orderDetail.bundleId === 'B0038'){
                            resumeFlowType = 'FCPResume';
                        }
                    }
                    xpsAction.preselectCartProductsForSCResume(cartProducts,voiceProduct,dispatch,visitId, resumeFlowType, buildProductState,lqState,saveState,cart,firstBill);
                    buildProductAction.getSpecialOffers(visitId, contract, dispatch);
                    buildProductAction.fetchOfferInCart(visitId, cartProducts, dispatch, contract,null,null,false,false,lqState);
                    
                    let isUnSupportedAvailable = getUnsupportedProducts(response.data, dispatch, visitId);
                    let isDisableUnSupported = (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.DisableUnSupported) && lqState.runtimeKey.DisableUnSupported === "Y") ? true: false;

                    if (isUnSupportedAvailable && isDisableUnSupported) {
                        qString = 'LOADCART-LQ-UNSUPPORTED';
                        errorMessage = 'LOADCART-LQ-UNSUPPORTED';
                        dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                        errorAction("LBO", "BuildProduct", errorMessage, "", visitId, dispatch, true, qString);
                        vzdlErrorUpdate(response.meta.code,errorMessage);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                    else if (creditCheckCompleted && personalInfoCompleted) {
                        if (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.DisableResumeCheckout) && lqState.runtimeKey.DisableResumeCheckout === "Y") {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                            redirectTo(Pages.BuildProduct, dispatch);
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.redirectToCheckout, PAGEACTIVITY.UA));
                            buildProductAction.updateCheckoutBtnStatus(true, dispatch);
                            checkoutAction.doValidateCart(visitId, dispatch,"","","",buildProductState);
                            checkoutAction.checkSatelliteEligible(dispatch, lqState.lqQualdetails, visitId);                            
                            //redirectTo(Pages.Checkout, dispatch);
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                        redirectTo(Pages.BuildProduct, dispatch);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', PAGEACTIVITY.MSG.cartEmpty + "-" + PAGEACTIVITY.MSG.redirectToBuildProducts, PAGEACTIVITY.UA));
                    smartcartflow(this.props.dispatch, false);
                    xpsAction.clearCart(visitId);
                    redirectTo(Pages.BuildProduct, dispatch);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
            else if (!isLoadCartFailed) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', "loadCartForSmartCart-ReAttempt", PAGEACTIVITY.UA));
                loadCartForSmartCart(visitId, dispatch, creditCheckCompleted, personalInfoCompleted,buildProductState, saveState,lqState,cart,firstBill, true);
            }
            else {
                let apiError = "";
                
                if (InHomeUtils.isNull(response)) {
                    errorMessage += "-ResponseNull";
                }else{
                    if (InHomeUtils.isNull(response.data)) {
                        errorMessage += "-DataNull";
                    }

                    if(InHomeUtils.isNotNull(response.meta)){
                        if(InHomeUtils.isNotNull(response.meta.code)){
                            errorMessage += "-" + response.meta.code;
                        }

                        if(InHomeUtils.isNotNull(response.meta.description)){
                            apiError = response.meta.description;
                        }
                    }
                }

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'loadCartForSmartCart', "RESPONSE FAILED:" + errorMessage + "-"+ apiError, PAGEACTIVITY.UA));

                if(InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y"){
                    dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                    errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
                    vzdlErrorUpdate(response.meta.code,errorMessage);
                }

                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            
        })
        .catch(error => {
            logOtherInfo(detailsInfo('loadCartForLQSmartCart', visitId, 'resumecart', "error is: " + error.message, PAGEACTIVITY.UA));
            vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            if (InHomeUtils.isNotEmpty(error.message)) {
                errorMessage += "-exception-" + error.message;
            }
            if(InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.EnableSmartCartLBO) && lqState.runtimeKey.EnableSmartCartLBO ==="Y"){
                dispatch({ type: 'UPDATE_LBO',  value: errorMessage });
                errorAction("LBO", "ResumeCart", errorMessage, "applogs", visitId, dispatch, true, qString);
            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-loadCartForSmartCart', ex);
    }
};

export const cancelSmartcart = (dispatch, visitId, saveState, tokenVal = null, redirectingTo = "BuildProducts", isLQResumeCancelled = null) => {
    try {
        let resumeMon = null;
        if (InHomeUtils.isNotNull(saveState) && InHomeUtils.isNotNull(saveState.saveResponse) && InHomeUtils.isNotNull(saveState.saveResponse.mon) && InHomeUtils.isNotEmpty(saveState.saveResponse.mon)) {
            resumeMon = saveState.saveResponse.mon;
            smartcartflow(dispatch, false);
            let url = apiUrl().smartcartCancel + '?mon=' + resumeMon + '&isLQResumeCancelled=' + isLQResumeCancelled;
           
            api(url, 'GET', '').then(response => {
                if (InHomeUtils.isNotNull(isLQResumeCancelled) && isLQResumeCancelled != undefined && InHomeUtils.isNotEmpty(isLQResumeCancelled) && isLQResumeCancelled == 'Y') {
                    xpsAction.captureSCResumeSource(dispatch,'smart cart lq resume cancel', saveState,visitId);
                    dispatch({ type: BuildProduct.monInvoked, value: false });
                    dispatch({ type: BuildProduct.monNo, value: "" });
                    dispatch({ type: BuildProduct.clearBuildProductState, value: "" });
                    loopQualAction.emptyCheckoutState(dispatch);

                }
                dispatch({ type: Save.cancelSmartcart, value: null });
                dispatch({ type: Save.cancelMon, value: null });
                dispatch({ type: CheckLQ.updateCouponFlowType, value: null });

                if (tokenVal !== undefined && tokenVal !== null && tokenVal !== "") {
                    lqAction.validateToken(tokenVal, dispatch, visitId, redirectingTo);
                }
                else {
                    if (redirectingTo === "PendingOrder") {
                        redirectTo(Pages.PendingOrder, dispatch)
                    }
                    else {
                        redirectTo(Pages.BuildProduct, dispatch)
                    }
                }

            })
                .catch(error => {
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                    let errorMsg = `MethodName:cancelSmartcart,errorMessage:${error.message}`;
                    logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
                });
        }

    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'cancelSmartcart', ex);
    }
};

export const smartcartflow = (dispatch, value) => {
    dispatch({ type: Save.issmartcartFlow, value: value });
};

const saveRequest = (lqState, email, mtn,visitId) => {
    try{
        let request = {
            addressID: (InHomeUtils.isNotNull(lqState.selectedUnit) && InHomeUtils.isNotNull(lqState.selectedUnit.addressId)
                && lqState.selectedUnit.addressId !== "" && lqState.selectedUnit.addressId !== "N") ? lqState.selectedUnit.addressId : lqState.selectedAdr.addressID,
            email: email,
            state: lqState.selectedState.state,
            mtn: "",
            client: "VZCOM",
            zip: lqState.selectedState.zip
        }
        return JSON.stringify(request);
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-saveRequest', ex);
        return JSON.stringify({ addressID: "", email: "", state: "", mtn: "", client: "VZCOM", zip: "" });
    }
}

const saveRequestRedirect = (lqState,visitId) => {
    try{
        let request = {
            addressID: lqState.addressID,
            email: "",
            state: lqState.state,
            mtn: "",
            client: "VZCOM",
            zip: lqState.zip
        }
        return JSON.stringify(request);
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-saveRequestRedirect', ex);
        return JSON.stringify({ addressID: "", email: "", state: "", mtn: "", client: "VZCOM", zip: "" });
    }
}

const sendRequest = (mon, smsOrEmail, isMtn,visitId) => {
    try{
        let today = new Date();
        let mm = today.getMonth() + 1;
        if (mm < 10) { mm = "0" + mm; }
        let dd = today.getDate();
        if (dd < 10) { dd = "0" + dd; }
        let y = today.getFullYear();
        let savedate = mm + '/' + dd + '/' + y;
        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: isMtn ? smsOrEmail : "",
            mon: mon,
            deliveryType: isMtn ? "SMS" : "EMAIL",
            cartCreateDate: savedate
        }
        return JSON.stringify(request);
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-sendRequest', ex);
        return JSON.stringify({ email: "", mtn: "", mon: "", deliveryType: "", cartCreateDate: "" });
    }
}

export const saveDate = (visitId) => {
    try{
        let today = new Date();
        let newdate = new Date();
        newdate.setDate(today.getDate() + 9);
        let dd = newdate.getDate();
        if (dd < 10) {
            dd = "0" + dd;
        }
        let mm = newdate.getMonth() + 1;
        if (mm < 10) { mm = "0" + mm; }
        let y = newdate.getFullYear();
        let savedate = mm + '/' + dd + '/' + y;
        return savedate;
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-saveDate', ex);
        return '';
    } 
}
